module.exports = __webpack_public_path__ + "img/hometop.1c383b67.png";